import { logOut } from '@/utils/auth';
import { Spin } from 'antd';
import { type FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const checkIsUrlFromIdentity = (searchParams: URLSearchParams) => searchParams.get('from') === 'identity';

export const OIDCAuthReset: FC = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isFromIdentity = checkIsUrlFromIdentity(searchParams);

  useEffect(() => {
    if (isFromIdentity) {
      logOut();
    }
  }, [isFromIdentity]);

  return <Spin size="default" style={{ height: 20 }} />;
};
